import { useId, useState } from "react";
import type { GlossaryEntry } from "@/types/content";

type CollapsibleKnowledgeCardProps = {
  entry: GlossaryEntry;
  className?: string;
};

export function CollapsibleKnowledgeCard({
  entry,
  className = "",
}: CollapsibleKnowledgeCardProps) {
  const [expanded, setExpanded] = useState(false);
  const panelId = useId();

  return (
    <div
      className={`overflow-hidden rounded-xl border border-[var(--line)] bg-paper shadow-card ${className}`.trim()}
    >
      <button
        type="button"
        onClick={() => setExpanded((e) => !e)}
        aria-expanded={expanded}
        aria-controls={panelId}
        className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left text-[13px] font-medium leading-snug text-ink-900"
      >
        <span className="min-w-0 flex-1">{entry.collapsedLabel}</span>
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className={`shrink-0 transition-transform ${expanded ? "rotate-180" : ""}`}
          aria-hidden
        >
          <path
            d="M3 5l4 4 4-4"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {expanded ? (
        <div
          id={panelId}
          className="flex flex-col gap-2 border-t border-[var(--line)] px-4 pb-4 pt-3"
        >
          <p className="text-[13.5px] font-semibold text-ink-900">{entry.title}</p>
          {entry.paragraphs.map((p) => (
            <p key={p} className="text-flow text-[13px] leading-relaxed text-ink-600">
              {p}
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
}
